/**
 * Carga de tipografías bajo demanda.
 *
 * Antes, `index.css` encadenaba CUATRO `@import url(...)` a Google Fonts con
 * diez familias (Inter dos veces, Caveat, Poppins, Manrope, Montserrat,
 * DM Sans, Outfit y Plus Jakarta Sans). Un `@import` dentro de una hoja de
 * estilos es RENDER-BLOCKING y además se descubre solo DESPUÉS de descargar la
 * hoja padre, así que se convierten en viajes de red encadenados que retrasan
 * la primera pintura aunque la landing use una sola tipografía.
 *
 * Ahora el CSS base solo trae Inter (la tipografía por defecto) y el resto se
 * añade con un `<link>` inyectado en caliente: no bloquea el render y solo se
 * descarga la familia que esa landing usa de verdad.
 */

const loaded = new Set<string>()
let preconnected = false

function preconnect(): void {
  if (preconnected || typeof document === 'undefined') return
  preconnected = true
  ;[
    ['https://fonts.googleapis.com', false],
    ['https://fonts.gstatic.com', true],
  ].forEach(([href, crossOrigin]) => {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = href as string
    if (crossOrigin) link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  })
}

/** Tipografías que ya vienen en el CSS base y no hay que volver a pedir. */
const BUILT_IN = new Set(['Inter', 'inherit', 'sans-serif', ''])

export function loadFont(family?: string, weights = '400;500;600;700'): void {
  if (typeof document === 'undefined') return
  const name = (family ?? '').trim()
  if (!name || BUILT_IN.has(name) || loaded.has(name)) return
  loaded.add(name)
  preconnect()
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `https://fonts.googleapis.com/css2?family=${name.replace(
    / /g,
    '+',
  )}:wght@${weights}&display=swap`
  document.head.appendChild(link)
}
